import React from 'react';
import SliderRow from './SliderRow/';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state           = { freqX:0, freqY:0, octaves:1, seed:0, type:'turbulence' };
    this.slideHandler    = this.slideHandler.bind(this);
    this.buttonHandler    = this.buttonHandler.bind(this);
  }

  slideHandler (ev) {
    this.setState({ [ev.target.name]: ev.target.value});
  }
  
  buttonHandler (ev) {
    // deactivate all buttons in buttonsP and activate this one
    let buttons = document.querySelectorAll('#buttonsP button');
    buttons.forEach(button => {
      button.style.borderStyle='outset';
      button.style.borderColor='#888';
      button.style.backgroundColor = '#ddd';
    });
    ev.target.style.borderStyle =     'inset';
    ev.target.style.borderColor =     '#aaf';
    ev.target.style.backgroundColor = '#fff';
    this.setState({ [ev.target.name]: ev.target.textContent});
  }
  
  // add more params for feTurbulence
  
  render() {
    return (
      <div>
      <p id="filterCodeP">
      &lt;feTurbulence baseFrequency="{this.state.freqX},{this.state.freqY}" numOctaves="{this.state.octaves}" seed="{this.state.seed}" type="{this.state.type}" />
</p>
      <svg>
      <defs>
      <filter id="turb1">
	<feTurbulence baseFrequency={[this.state.freqX, this.state.freqY]} numOctaves={this.state.octaves} seed={this.state.seed} type={this.state.type} />
      </filter>
      </defs>
      <rect width="100%" height="100%" filter="url(#turb1)" />
      </svg>

      <div id="controls">

      <SliderRow slideHandler={this.slideHandler} name="freqX"   value={this.state.freqX}   min={0} max={1}    step={.001} label="BaseFrequency X" />
      <SliderRow slideHandler={this.slideHandler} name="freqY"   value={this.state.freqY}   min={0} max={1}    step={.001} label="BaseFrequency Y" />
      <SliderRow slideHandler={this.slideHandler} name="octaves" value={this.state.octaves} min={1} max={5}    step={1}    label="Octaves" />
      <SliderRow slideHandler={this.slideHandler} name="seed"    value={this.state.seed}    min={0} max={1000} step={1}    label="Seed" />

      <div className="row">
      <p className="label">type</p>
      <p id="buttonsP" role="group" aria-label="...">
      <button name="type" onClick={this.buttonHandler}>fractalNoise</button>
      <button id="turbButton" name="type" onClick={this.buttonHandler}>turbulence</button>
      </p>
      </div>
          

      </div>

      </div>
    );
  }
}

export default App;
